import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
import languageAM from "./locale/am/translate.json";
import languageEN from "./locale/en/translate.json";
import languageOM from "./locale/om/translate.json";
import languageSO from "./locale/so/translate.json";
import languageTI from "./locale/ti/translate.json";

const options = {
  order: ["localStorage", "navigator"],
  lookupQuerystring: "lng",
};

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      am: languageAM,
      en: languageEN,
      om: languageOM,
      so: languageSO,
      ti: languageTI,
    },
    /* default language when load the website in browser */
    lng: "am",
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "am",
    /* debugger For Development environment */
    debug: true,
    detection: options,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true,
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
  });

export default i18n;
